class NwFaq extends HTMLElement {
  constructor() {
    super();

    this.isMobile = false;
    this.enableScroll = null;
    this.searchCacheData = [];
  }

  connectedCallback() {
    const faqJson = JSON.parse(this.querySelector('[type="application/json"]').textContent || '{}');
    this.faqList = window.$utils.get(faqJson, 'list', []);

    this.getFlattenFaqList();

    this.searchInput = this.querySelector('.search-input');
    const searchButton = this.querySelector('.search-button');
    const backToFaqBtnList = [this.querySelector('.clear-button')].filter(item => item);
    this.noResultsQueryList = Array.from(this.querySelectorAll('.search-no-results .search-query'));

    if (backToFaqBtnList.length) {
      backToFaqBtnList.forEach((item) => {
        item.addEventListener('click', () => {
          if (this.searchInput) this.searchInput.value = '';
          this.clearSearchResults();
        });
      });
    }

    if (searchButton) {
      searchButton.addEventListener('click', (event) => {
        this.search(event);
      });
    }

    this.searchInput.addEventListener('input', debounce((event) => {
      this.search(event);
    }, 500).bind(this));

    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    const leftWrapper = this.querySelector('.left-wrapper');
    let isUpdatingMaxHeight = false;

    this.observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        if (isUpdatingMaxHeight) return;
        isUpdatingMaxHeight = true;
        if (this.isMobile) {
          leftWrapper.style.maxHeight = `none`;
        } else {
          leftWrapper.style.maxHeight = entry.contentRect.height + 'px';
        }
        setTimeout(() => {
          isUpdatingMaxHeight = false;
        }, 200);
      }
    });
    this.observer.observe(this.querySelector('.mobile-filter-content-wrapper'));

    this.checkIsMobile = () => {
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      const isMobile = width <= 650;
      if (this.isMobile === isMobile) return;

      this.isMobile = isMobile;

      if (this.isMobile) {
        this.classList.add('is-mobile');
      } else {
        this.classList.remove('is-mobile');
        this.toggleScrollHandler();
      }
    }

    this.checkIsMobile();
    window.addEventListener('resize', window.$utils.throttle(this.checkIsMobile, 200));

    const toggleFilterBtnList = [this.querySelector('.mobile-filter-overlay'), this.querySelector('.filter-button'), this.querySelector('.mobile-filter-header-wrapper .close-button')].filter(item => item);

    toggleFilterBtnList.forEach(item => {
      item.addEventListener('click', (event) => {
        this.toggleScrollHandler();
      });
    });

    // Left Navigation Array
    this.navLinkList = Array.from(this.querySelectorAll('.faq-nav-wrapper .nav-link'));
    // Right Pane Array
    this.paneList = Array.from(this.querySelectorAll('.tab-content .tab-pane'));

    const that = this;
    const filterCategoryLabel = this.querySelector('.mobile-filter-wrapper .category-label');
    $('button[data-toggle="pill"]').on('show.bs.tab', function (event) {
      if (filterCategoryLabel) filterCategoryLabel.textContent = (event.target.textContent || '').replace('(', '').replace(')', '');
      that.toggleScrollHandler();
      if (!this.isMobile) {
        window.$utils.scrollIntoView('.nw-faq-wrapper');
      }
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    window.removeEventListener('resize', this.checkIsMobile);
  }

  toggleScrollHandler() {
    if (this.classList.contains('is-filter-active')) {
      this.classList.remove('is-filter-active');
      this.classList.add('is-filter-closed');

      if (this.enableScroll) {
        this.enableScroll();
        this.enableScroll = null;
      };
    } else {
      if (!this.isMobile) return;

      this.classList.add('is-filter-active');
      this.classList.remove('is-filter-closed');

      this.enableScroll = window.$utils.disableScroll();
    }
  }

  getQuery() {
    return this.searchInput ? this.searchInput.value : '';
  }

  onKeyup(event) {
    if (!this.getQuery().length) return false;
    event.preventDefault();
    switch (event.code) {
      case 'Enter':
        this.search(event);
        break;
      case 'NumpadEnter':
        this.search(event);
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'Enter' ||
      event.code === 'NumpadEnter'
    ) {
      event.preventDefault();
    }
  }

  search(event) {
    const query = this.getQuery();
    if (!query.length) {
      this.clearSearchResults();
      return false;
    };

    const searchData = this.searchCacheData.find(item => item.query === query);
    if (searchData) {
      this.renderSearchResults({
        ...searchData,
        isCache: true
      });
    } else {
      this.renderSearchResults({
        query,
        list: this.flattenFaqList.filter(item => {
          const questionStatus = item.question.toLowerCase().includes(query.toLowerCase());
          const answersStatus = item.answers.some(answer => answer.toLowerCase().includes(query.toLowerCase()));
          return questionStatus || answersStatus;
        })
      });
    }

    // this.toggleScrollHandler();
  }

  renderSearchResults(options) {
    const {
      query,
      list,
      navList,
      isCache
    } = Object.assign({}, {
      query: '',
      list: [],
      navList: [],
      isCache: false
    }, options);

    this.updateNoResultsQuery(query);

    const navCountList = isCache ? navList : this.faqList.reduce((acc, item, index) => {
      const filterList = list.filter(subItem => subItem.index === index);
      acc.push({
        title: item.title,
        count: filterList.length,
        filterList
      });
      return acc;
    }, []);

    // Update nav link count
    if (this.navLinkList && this.navLinkList.length) {
      this.navLinkList.forEach((nav, index) => {
        if (nav.querySelector('.category-count')) {
          nav.querySelector('.category-count').setAttribute('data-search-count', navCountList[index].count);
        }
      });
    }

    // Update the qa list active status, and the no results message status
    if (this.paneList && this.paneList.length) {
      this.paneList.forEach((pane, index) => {
        const qaList = Array.from(pane.querySelectorAll('.nw-qa-item-wrapper'));
        qaList.forEach((item, subIndex) => {
          if (navCountList[index].filterList.find(subItem => subItem.subIndex === subIndex)) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        if (navCountList[index].count === 0) {
          pane.querySelector('.search-no-results').classList.add('active');
        } else {
          pane.querySelector('.search-no-results').classList.remove('active');
        }
      });
    }

    this.classList.add('search-results-active');

    if (!isCache) {
      this.searchCacheData.push({
        query,
        list,
        navList: navCountList
      });
    }

    window.$utils.nextTick(() => {
      window.$utils.scrollIntoView('.nw-faq-wrapper');
    });
  }

  getFlattenFaqList() {
    this.flattenFaqList = this.faqList.flatMap((item, index) =>
      (item.list || []).map((subItem, subIndex) => ({
        title: item.title,
        index,
        subIndex,
        ...subItem
      }))
    );
  }

  updateNoResultsQuery(query) {
    if (this.noResultsQueryList && this.noResultsQueryList.length) {
      this.noResultsQueryList.forEach((item) => {
        item.textContent = query;
      });
    }
  }

  clearSearchResults() {
    this.classList.remove('search-results-active');
  }

}
customElements.define('nw-faq', NwFaq);